import { CLEAR_RESPONSE, LOADING, RESET_RESPONSE, SET_RESPONSE } from "../actions/actionTypes";

const initialState = {
  loading: null,
  success: null,
  message: ""
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        loading: action.loading
      };
    case SET_RESPONSE:
      return {
        success: action.success,
        message: action.message
      };
    case CLEAR_RESPONSE:
      return {};
    case RESET_RESPONSE:
      return initialState
    default:
      return state;
  }
};

export default reducer;
